// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3wNQ0","OrderButton":"BuildControls_OrderButton__2tSAi","enable":"BuildControls_enable__1B9WH"};